import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TextField,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import Download from "../../common/assets/images/Download.svg";
import Close from "../../common/assets/images/Close.svg";
import { Link } from "react-router-dom";
import { Buffer } from "buffer";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import "../../poppins/Poppins-Regular-normal";
import "../../poppins/Poppins-Bold-bold";
import { Chart as ChartJS, registerables } from "chart.js";

import { Line } from "react-chartjs-2";
import Chart from "react-apexcharts";
//import "chartjs-plugin-doughnutlabel";

import { GetGenderDistributionData } from "../reducers/ReportsDataThunk";

import "../../dataEntry/styles/DataEntry.scss";
import NotificationView from "../../Dashboard/components/NotificationView";
import NotificationPdf from "./NotificationPdf";
import ChartLegends from "./ChartLegends";

const GenderDistribution = () => {
  ChartJS.register(...registerables);
  const patient = useSelector((state) => state.patient);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [doughnutData, setDoughnutData] = React.useState();
  const [lineChartData, setLineChartData] = React.useState();
  const [chartData, setChartData] = React.useState();
  const hospital_name = user.userProfile.hospital_name;
  const hospital_id = user.userProfile.hospital_id;
  const branch = useSelector((state) => state.Reports?.SelectedBranchdata);
  const [rangeType, setRangeType] = React.useState("Select Dates");
  const [sepsisStatus, setSepsisStatus] = React.useState("positive");
  const [notificationData, setNotificationData] = React.useState(null);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [fromDate, setFromDate] = React.useState(
    moment().subtract(1, "month").format()
  );
  const [toDate, setToDate] = React.useState(moment().format());
  const [fromYear, setFromYear] = React.useState(
    moment().subtract(1, "year").format()
  );
  const [toYear, setToYear] = React.useState(moment().format());
  const [month, setMonth] = React.useState(moment().format());
  const [isLoading, setIsLoading] = React.useState(false);
  const [enableDownload, setEnableDownload] = React.useState(false);
  React.useEffect(() => {
    if (chartData && chartData.length) {
      const labels = [],
        males = [],
        females = [];

      chartData.map((record) => {
        labels.push(record.label);
        males.push(record.males);
        females.push(record.females);
      });

      const LineChartResponse = {
        labels,
        datasets: [
          { label: "Male", borderColor: "#5D66ED", data: males },
          { label: "Fe Male", borderColor: "#EB81C1", data: females },
        ],
      };
      setLineChartData(LineChartResponse);
    }
  }, [chartData]);

  useEffect(() => {
    getReports();
  }, [
    rangeType,
    fromDate,
    toDate,
    month,
    fromYear,
    toYear,
    branch.hospital_branch_id,
    sepsisStatus,
  ]);

  const getReports = () => {
    setIsLoading(true);
    let params;

    switch (rangeType) {
      case "Select Dates":
        params = {
          sepsisStatus: sepsisStatus,
          range: "custom",
          start: moment(fromDate).format("MM-DD-YYYY"),
          end: moment(toDate).format("MM-DD-YYYY"),
        };
        break;
      case "Monthly":
        params = {
          sepsisStatus: sepsisStatus,
          range: "monthly",
          start: moment(month).format("MM-DD-YYYY"),
        };
        break;
      case "Quarterly":
        params = {
          sepsisStatus: sepsisStatus,
          range: "quarterly",
        };
        break;
      case "Yearly":
        params = {
          sepsisStatus: sepsisStatus,
          range: "yearly",
          start: moment(fromYear).format("MM-DD-YYYY"),
          end: moment(toYear).format("MM-DD-YYYY"),
        };
        break;
    }

    const req = { hospital_id, branch_id: branch.hospital_branch_id, params };
    dispatch(GetGenderDistributionData(req))
      .unwrap()
      .then((resdata) => {
        const doughnutChartData = {
          options: {
            labels: ["Male", "Female"],
            dataLabels: {
              enabled: true,
              style: {
                fontFamily: "Poppins",
              },
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    total: {
                      showAlways: true,
                      show: true,
                      fontFamily: "Poppins",
                      color: "#aeaeae",
                    },
                    value: {
                      fontFamily: "Poppins",
                      fontSize: "24px",
                    },
                  },
                },
              },
            },
            fill: { colors: ["#5D66ED", "#EB81C1"] },
            colors: ["#5D66ED", "#EB81C1"],
            legend: {
              show: false,
            },
          },
          series: [resdata.response.malesCount, resdata.response.femalesCount],
        };

        /*  const doughnutResponse = {
          // labels: ["Male", "Fe Male"],
          datasets: [
            {
              data: [
                resdata.response.malesCount,
                resdata.response.femalesCount,
              ],
              backgroundColor: ["#5D66ED", "#EB81C1"],
            },
          ],
        };
 */
        setEnableDownload(
          resdata.response.malesCount > 0 || resdata.response.femalesCount > 0
            ? true
            : false
        );
        setIsLoading(false);
        setDoughnutData(doughnutChartData);
        setChartData(resdata.response.graphData);
      });
  };

  const div2PDF = async (e) => {
    e.preventDefault();
    let doughnutChart =
      window.document.getElementsByClassName("doughnutChart")[0];
    const doughnutChartCanvas = await html2canvas(doughnutChart);
    const doughnutChartImage = doughnutChartCanvas.toDataURL("image/png");

    let lineChart =
      window.document.getElementsByClassName("genderLineChart")[0];
    const lineChartCanvas = await html2canvas(lineChart);
    const lineChartImage = lineChartCanvas.toDataURL("image/png");

    const pdf = new jsPDF("l", "pt", "a4");
    pdf.setFont("Poppins", "normal");
    pdf.setFillColor(244, 131, 81);
    pdf.rect(50, 90, 740, 40, "F");

    pdf.setFont("Poppins-Bold", "bold");
    pdf.setFontSize(20);
    const heading = "Gender Distribution Report";
    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(20);
    pdf.text(heading, 290, 115);
    var avyantraImage = new Image();
    avyantraImage.src = "./assets/avyantra.jpg";
    pdf.addImage(avyantraImage, "jpg", 10, 10, 60, 13);

    pdf.setFontSize(10);
    pdf.setTextColor(135, 135, 135);
    pdf.text(`Generated On: ${moment().format("DD-MM-YYYY")}`, 700, 20);

    var prescoImage = new Image();
    prescoImage.src = "./assets/presco.png";
    pdf.addImage(prescoImage, "png", 380, 30, 53.5, 14.12);
    pdf.text("Neonatal Sepsis Prediction Platform", 330, 60);

    pdf.setFontSize(15);
    pdf.setTextColor(135, 135, 135);

    let rangeValue;
    switch (rangeType) {
      case "Select Dates":
        rangeValue =
          moment(fromDate).format("DD-MM-YY") +
          " To " +
          moment(toDate).format("DD-MM-YY");
        break;
      case "Yearly":
        rangeValue =
          moment(fromYear).format("YYYY") +
          " To " +
          moment(toYear).format("YYYY");
        break;
      case "Monthly":
        rangeValue =
          moment(month).startOf("month").format("DD-MM-YY") +
          " To " +
          moment(month).endOf("month").format("DD-MM-YY");
        break;
      case "Quarterly":
        rangeValue =
          moment().startOf("quarter").format("DD-MM-YY") +
          " To " +
          moment().endOf("quarter").format("DD-MM-YY");
        break;
    }

    // Calculate the width of each label text
    const labelWidths = {
      "Hospital: ":
        (pdf.getStringUnitWidth("Hospital: ") * pdf.internal.getFontSize()) /
        pdf.internal.scaleFactor,
      "Branch: ":
        (pdf.getStringUnitWidth("Branch: ") * pdf.internal.getFontSize()) /
        pdf.internal.scaleFactor,
      "Range: ":
        (pdf.getStringUnitWidth("Range: ") * pdf.internal.getFontSize()) /
        pdf.internal.scaleFactor,
    };

    const totalWidth =
      labelWidths["Hospital: "] +
      labelWidths["Branch: "] +
      labelWidths["Range: "];
    const availableSpace = pdf.internal.pageSize.getWidth() - 110 - totalWidth; // Total width - x-coordinate of first label

    const spaceBetweenLabels = availableSpace / 2;

    const labelX = {
      "Hospital: ": 55,
      "Branch: ": 10 + labelWidths["Hospital: "] + spaceBetweenLabels,
      "Range: ":
        pdf.internal.pageSize.getWidth() -
        labelWidths["Range: "] -
        `${rangeType !== "Yearly" ? 230 : 130}`,
    };

    pdf.setFontSize(15);

    pdf.setFont("Poppins", "normal");
    pdf.text(`Hospital :`, labelX["Hospital: "], 160);
    pdf.text(`Branch :`, labelX["Branch: "], 160);
    pdf.text(`Range :`, labelX["Range: "], 160);

    pdf.setFont("Poppins-Bold", "bold");
    pdf.text(`${hospital_name}`, labelX["Hospital: "] + 75, 160);
    pdf.text(`${branch.branch_name}`, labelX["Branch: "] + 70, 160);
    pdf.text(`${rangeValue}`, labelX["Range: "] + 70, 160);

    pdf.addImage(doughnutChartImage, "png", 50, 190, 290, 250);
    pdf.addImage(lineChartImage, "png", 350, 190, 390, 250);
    const blobData = pdf.output("arraybuffer");
    const buffer = Buffer.from(blobData);
    setNotificationData(buffer);
    setDialogOpen(true);
  };

  const lineOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: `${rangeType !== "Select Dates" ? "Year" : "Date"}`,
        },
        grid: {
          display: false,
        },
      },
      y: {
        title: {
          display: true,
          text: "Count",
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <React.Fragment>
      <NotificationPdf
        data={notificationData}
        open={dialogOpen}
        action={setDialogOpen}
        title="Gender Distribution"
      />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div>
          <Card variant="none">
            <CardContent style={{padding:"0px 5px"}}>
              <div>
                <div className="reports_chart_title">
                  {/* <Grid container>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      style={{
                        margin: "0px auto",
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Gender Distribution
                    </Grid>
                  </Grid>
                  <hr /> */}
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <Grid
                      item
                      xs={12}
                      sm={3}
                      style={{
                        // margin: "0px auto",
                        // textAlign: "center",
                        marginTop: 30,
                        fontSize: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Gender Distribution
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <Grid container>
                        <Grid item xs={12} sm={2}>
                          <label
                            htmlFor="Sepsis Status"
                            className="dataentry_label1"
                            style={{ display: "block" }}
                          >
                            Sepsis Status
                          </label>
                          <Select
                            labelId="sepsis_status"
                            id="sepsis_status"
                            name="sepsis_status"
                            label=""
                            size="small"
                            className="dataentry_input"
                            value={sepsisStatus}
                            onChange={(e) => {
                              setSepsisStatus(e.target.value);
                            }}
                            style={{ fontSize: "14px", padding: "3px 0px" }}
                          >
                            <MenuItem value="positive">Positive</MenuItem>
                            <MenuItem value="negative">Negative</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <label
                            htmlFor="Range"
                            className="dataentry_label1"
                            style={{ display: "block" }}
                          >
                            Range
                          </label>
                          <Select
                            labelId="range"
                            id="range"
                            name="range"
                            label=""
                            size="small"
                            className="dataentry_input"
                            value={rangeType}
                            onChange={(e) => {
                              setRangeType(e.target.value);
                            }}
                            style={{ fontSize: "14px", padding: "3px 0px" }}
                          >
                            <MenuItem value="Select Dates">
                              Select Dates
                            </MenuItem>
                            <MenuItem value="Yearly">Yearly</MenuItem>
                            <MenuItem value="Monthly">Monthly</MenuItem>
                            <MenuItem value="Quarterly">Quarterly</MenuItem>
                          </Select>
                        </Grid>

                        {rangeType === "Quarterly" && (
                          <Grid item xs={12} sm={6}></Grid>
                        )}

                        {rangeType === "Yearly" ? (
                          <>
                            <Grid item xs={12} sm={3}>
                              <label
                                htmlFor="From"
                                className="dataentry_input"
                                style={{ display: "block" }}
                              >
                                From
                              </label>
                              <DatePicker
                                size="small"
                                id="from_year"
                                name="from_year"
                                views={["year"]}
                                minDate="01-01-2019"
                                maxDate={toYear}
                                value={fromYear}
                                className="dataentry_input"
                                onChange={(date) => {
                                  setFromYear(date["$d"]);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    className="dataentry_input"
                                    helperText={null}
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                   }}
                                   autocomplete="off"
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <label
                                htmlFor="To"
                                className="dataentry_label1"
                                style={{ display: "block" }}
                              >
                                To
                              </label>
                              <DatePicker
                                size="small"
                                views={["year"]}
                                id="to_year"
                                name="to_year"
                                value={toYear}
                                minDate={fromYear}
                                maxDate={moment().format()}
                                className="dataentry_input"
                                onChange={(date) => {
                                  setToYear(date["$d"]);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    className="dataentry_input"
                                    size="small"
                                    helperText={null}
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                   }}
                                   autocomplete="off"
                                  />
                                )}
                              />
                            </Grid>
                          </>
                        ) : null}

                        {rangeType === "Select Dates" ? (
                          <>
                            <Grid item xs={12} sm={3}>
                              <label
                                htmlFor="From"
                                className="dataentry_label1"
                                style={{ display: "block" }}
                              >
                                From
                              </label>
                              <DatePicker
                                id="from_month"
                                size="small"
                                name="from_month"
                                className="dataentry_input"
                                inputFormat="DD-MM-YYYY"
                                minDate="01-01-2019"
                                maxDate={toDate}
                                value={fromDate}
                                onChange={(date) => {
                                  setFromDate(date["$d"]);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    className="dataentry_input"
                                    helperText={null}
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                   }}
                                   autocomplete="off"
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <label
                                htmlFor="To"
                                className="dataentry_label1"
                                style={{ display: "block" }}
                              >
                                To
                              </label>
                              <DatePicker
                                id="to_month"
                                name="to_month"
                                size="small"
                                className="dataentry_input"
                                inputFormat="DD-MM-YYYY"
                                minDate={fromDate}
                                maxDate={moment().format()}
                                value={toDate}
                                onChange={(date) => {
                                  setToDate(date["$d"]);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    className="dataentry_input"
                                    helperText={null}
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                   }}
                                   autocomplete="off"
                                  />
                                )}
                              />
                            </Grid>
                          </>
                        ) : null}

                        {rangeType === "Monthly" ? (
                          <>
                            <Grid item xs={12} sm={3}>
                              <label
                                htmlFor="From"
                                className="dataentry_label1"
                                style={{ display: "block" }}
                              >
                                Month
                              </label>
                              <DatePicker
                                id="from_month"
                                name="from_month"
                                size="small"
                                inputFormat="DD-MM-YYYY"
                                className="dataentry_input"
                                value={month}
                                minDate="01-01-2019"
                                maxDate={moment().format()}
                                views={["year", "month"]}
                                onChange={(date) => {
                                  setMonth(date["$d"]);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    className="dataentry_input"
                                    helperText={null}
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                   }}
                                   autocomplete="off"
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}></Grid>
                          </>
                        ) : null}

                        <Grid item xs={12} sm={2}>
                          <Button
                            variant="contained"
                            size="small"
                            className="report-download-button"
                            disabled={isLoading || !enableDownload}
                            onClick={(e) => div2PDF(e)}
                          >
                            Download Report
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
                <hr className="tag-line-border" />
                {isLoading ? (
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    style={{
                      height: "480px",
                    }}
                  >
                    <Grid sm={1}>
                      <CircularProgress color="success" />
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container spacing={2}>
                    {(doughnutData && doughnutData.series[0] !== 0) ||
                    (doughnutData && doughnutData.series[1] !== 0) ? (
                      <>
                        <Grid item xs={12} sm={5} className="doughnutChart">
                          <div className="chart_data">
                            <p className="chart_title">
                              Percentage of cases on Gender Basis
                            </p>
                            <div className="chart-body">
                              {doughnutData ? (
                                <Chart
                                  series={doughnutData.series}
                                  options={doughnutData.options}
                                  type="donut"
                                  width="380"
                                />
                              ) : null}
                            </div>
                          </div>
                          <ChartLegends
                            labelOne={"Male"}
                            labelTwo={"Female"}
                            colorOne={"#5D66ED"}
                            colorTwo={"#F28ECB"}
                            /* labelOneCount={
                              doughnutData
                                ? doughnutData.datasets[0].data[0]
                                : null
                            }
                            labelTwoCount={
                              doughnutData
                                ? doughnutData.datasets[0].data[1]
                                : null
                            } */
                          />
                        </Grid>
                        <Grid item xs={12} sm={7} className="genderLineChart">
                          <div className="chart_data">
                            <p className="chart_title">
                              Sepsis status of Male and Female
                            </p>
                            {lineChartData ? (
                              <Line
                                data={lineChartData}
                                options={lineOptions}
                                className="donut_class"
                              />
                            ) : null}
                          </div>
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Grid
                          container
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                          style={{
                            height: "480px",
                          }}
                        >
                          <Grid sm={4}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                alignItems: "center",
                                margin: "1rem 0",
                              }}
                            >
                              No data Found
                            </div>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      </LocalizationProvider>
    </React.Fragment>
  );
};

export default GenderDistribution;
